import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NgxSpinnerModule } from "ngx-spinner";
import { TopBarComponent } from './pages/top-bar/top-bar.component';
import dayjs from 'dayjs'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import localeData from 'dayjs/plugin/localeData'
import localeEN from 'dayjs/locale/en'
import localeIT from 'dayjs/locale/it'
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { FooterComponent } from './pages/footer/footer.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NgxSpinnerModule, TopBarComponent, TranslatePipe, FooterComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {

  translate = inject(TranslateService);

  constructor() {
    const lang = navigator.language.substr(0, 2);
    this.translate.use(lang);

    dayjs.extend(localizedFormat);
    dayjs.extend(localeData);
    dayjs.locale(localeEN);

    this.translate.onLangChange.subscribe(lang => {
      if (lang.lang === 'en') {
        dayjs.locale(localeEN);
      } else {
        dayjs.locale(localeIT);
      }
    });
  }
}
